import React from 'react';
import PropTypes from 'prop-types';
export var Variant = function Variant(_ref) {
  var children = _ref.children;
  return children && React.Children.only(children);
};
Variant.displayName = 'Variant';
Variant.defaultProps = {
  children: null
};
Variant.propTypes = {
  variantName: PropTypes.string.isRequired,
  children: PropTypes.node
};
export var Control = function Control(_ref2) {
  var children = _ref2.children;
  return children && React.Children.only(children);
};
Control.displayName = 'Control';
Control.defaultProps = {
  variantName: 'control',
  children: null
};
Control.propTypes = {
  variantName: PropTypes.string.isRequired,
  children: PropTypes.node
};